import { ZodIssueCode, z } from "zod";
import { fromBase64Url } from "@cerbos/spitfire-shared/base64url";
import { toUtf8 } from "./bytes.js";
import { parse } from "./json.js";
export const nonEmptyStringSchema = z.string().min(1);
export const base64UrlSchema = z
    .string()
    .transform((value, ctx) => {
    try {
        return fromBase64Url(value);
    }
    catch (error) {
        return fail(ctx, "Invalid encoding");
    }
});
export const booleanStringSchema = z
    .enum(["true", "false"])
    .transform((value) => {
    return value === "true";
});
export function encryptedSchema() {
    return nonEmptyStringSchema.transform((value) => value);
}
export function fail(ctx, message) {
    ctx.addIssue({ code: ZodIssueCode.custom, message, fatal: true });
    return z.NEVER;
}
export function urlSchema(...protocols) {
    return nonEmptyStringSchema.transform((value, ctx) => {
        try {
            const url = new URL(value);
            if (!protocols.some((protocol) => url.protocol === `${protocol}:`)) {
                return fail(ctx, `Protocol must be one of ${protocols.toString()}`);
            }
            if (!url.host) {
                return fail(ctx, "Missing host");
            }
            return url;
        }
        catch {
            return fail(ctx, "Invalid URL");
        }
    });
}
export const httpUrlSchema = urlSchema("https", "http");
export const httpsUrlSchema = urlSchema("https");
export const jsonStringSchema = z.string().transform((value, ctx) => {
    try {
        return parse(value);
    }
    catch {
        return fail(ctx, "Invalid encoding");
    }
});
export const logLevelSchema = z.enum([
    "silent",
    "error",
    "warn",
    "info",
    "debug",
    "trace",
]);
export const redisUrlSchema = urlSchema("redis").superRefine((value, ctx) => {
    if (!(value instanceof URL)) {
        // already failed validation
        return z.NEVER;
    }
    value.search = ""; // TODO: map go-redis query string parameters to ioredis query string parameters
    if (value.port === "") {
        value.port = "6379";
    }
    if (!/^\/(?:\d|[1-9]\d*)$/.test(value.pathname)) {
        return fail(ctx, "URL path must be a valid database number");
    }
});
export const utf8Schema = z
    .instanceof(Uint8Array)
    .transform((value, ctx) => {
    try {
        return toUtf8(value);
    }
    catch (error) {
        return fail(ctx, "Invalid encoding");
    }
});
//# sourceMappingURL=schema.js.map